import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ForeignAddress, ForeignAddressForm } from './foreign-address.model';

/**
 * @ngdoc service
 * @name ApForeignAddressService
 */
@Injectable()
export class ApForeignAddressService {
    /**
     * @ngdoc method
     * @name ApForeignAddressService#createFormGroup
     * @methodOf ApForeignAddressService
     *
     * @param isRequired sets all fields to required
     * @param foreignAddress the foreign address to initialize the form
     *
     * @returns The value
     *
     * @description
     *
     */
    public createFormGroup(isRequired: boolean, foreignAddress: ForeignAddress = new ForeignAddress()): FormGroup<ForeignAddressForm> {
        const foreignAddressPattern = /^[0-9A-Za-z\-\s\\/.,']+$/;
        return new FormGroup<ForeignAddressForm>({
            line1: new FormControl<string>(foreignAddress.line1, [
                Validators.maxLength(32),
                Validators.pattern(foreignAddressPattern),
                Validators.required
            ]),
            line2: new FormControl<string>(foreignAddress.line2, [
                Validators.maxLength(32),
                Validators.pattern(foreignAddressPattern),
                Validators.required
            ]),
            line3: new FormControl<string>(foreignAddress.line3, [Validators.maxLength(32), Validators.pattern(foreignAddressPattern)]),
            country: new FormControl<string>(foreignAddress.country?.name, isRequired ? [Validators.required] : [])
        });
    }
}
